import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 登录
interface LoginData {
    username: string,
    password: string,
    imageCode: string,
    smsCode: string
}
export const login = (data: LoginData): any => $fn.httpPost({
    url: httpApi.user.login,
    data,
})

// 登出
export const logout = () => $fn.httpPost({
    url: httpApi.user.logout,
})

// 获取用户信息
interface InfoJson {
    token: string
}
export const getUserInfo = (): any => http.httpGet({
    url: httpApi.user.getInfo,
})

// 获取用户信息(新)
export const newGetUserInfo = (): any => http.httpGet({
    url: httpApi.user.newGetInfo,
})

// 获取用户信息
export const getMenu = (): any => $fn.httpPost({
    url: httpApi.user.getMenu,
})

interface GetId {
    id: string
}
export const getUserInfoDemo = (data: GetId): any => $fn.httpPost({
    url: httpApi.user.getUserInfo,
    data
})

// 反馈意见类型配置

export const opinionConfig = (): any => $fn.httpGet({
    url: httpApi.user.opinionConfig,
})

// 反馈意见
interface Feedback {
    token: string,
    type: number,
    content: string,
    image: any,
    phone: string
}
export const feedBack = (json: Feedback): any => $fn.httpPost({
    url: httpApi.user.buyOrder,
    json,
})

// 我的收藏
interface CollectListJson {
    size: string,
    page: string,
    type: string
}
export const collectList = (json: CollectListJson): any => http.httpGet({
    url: httpApi.user.collectList,
    json,
})

// 我的货架
interface SellJson {
    size: string,
    page: string,
    type: string
}
export const sell = (json: SellJson): any => http.httpGet({
    url: httpApi.user.sell,
    json,
})

// 上架商品
interface OnshelfJson {
    commodity_id: string,
}
export const onshelf = (json: OnshelfJson): any => http.httpPost({
    url: httpApi.user.onshelf,
    json,
})

// 下架
export const downshelf = (json: OnshelfJson): any => http.httpPost({
    url: httpApi.user.downshelf,
    json,
})

// 取回
export const takeBack = (json: OnshelfJson): any => http.httpPost({
    url: httpApi.user.takeBack,
    json,
})

// 修改价格
interface ModifyPriceJson {
    commodity_id: string,
    price: string,
}
export const modifyPrice = (json: ModifyPriceJson): any => http.httpPost({
    url: httpApi.user.modifyPrice,
    json,
})

interface ImageUploadJson {
    module: string,
    base64: string,
}

// 上传图片
export const imageUpload = (data: ImageUploadJson): any => http.httpPost({
    url: httpApi.user.imageUpload,
    dataType: 'json',
    data,
})

// 我要卖数据接口
interface SellInfoJson {
    box_game_id: string,
    server_id: string,
}
export const sellInfo = (json: SellInfoJson): any => http.httpGet({
    url: httpApi.user.sellInfo,
    json,
})

// 获取角色货币余额
interface CoinNumJson {
    box_game_id: string,
    server_id: string,
    role_id: string,
}
export const coinNum = (json: CoinNumJson): any => http.httpGet({
    url: httpApi.user.coinNum,
    json,
})

interface SendSmsJson {
    a: string,
}
// 给用户的手机号发送验证码
export const sendSms = (json: SendSmsJson) => http.httpPost({
    url: httpApi.user.sendSms,
    json
})

// 校验验证码
interface CheckSmsJson {
    phone: string,
    code: string,
}
export const checkSms = (json: CheckSmsJson): any => http.httpPost({
    url: httpApi.user.checkSms,
    json,
})

// 发布商品
interface PublishJson {
    box_game_id: string,
    server_id: string,
    role_id: string,
    coin_config_id: string,
    coin_num: string,
    price: string,
    code: string,
    target_role: string,
}
export const publish = (json: PublishJson): any => http.httpPost({
    url: httpApi.user.publish,
    json,
})

// 指定我
interface TargetJson {
    size: string,
    page: string,
}
export const target = (json: TargetJson): any => http.httpGet({
    url: httpApi.user.target,
    json,
})

// 删除指定
interface CancelTargetJson {
    commodity_id: string,
}
export const cancelTarget = (json: CancelTargetJson): any => http.httpPost({
    url: httpApi.user.cancelTarget,
    json,
})

// 身份证照片获取身份证信息
interface IdcardJson {
    idcard_front: string,
    type: string,
}
export const authidcard = (json: IdcardJson): any => http.httpPost({
    url: httpApi.user.authidcard,
    json,
})

// 提交实名信息
interface PersonalJson {
    front_id: string,
    back_id: string,
    idcard_front: string,
    idcard_back: string,
}
export const authpersonal = (json: PersonalJson): any => http.httpPost({
    url: httpApi.user.authpersonal,
    json,
})


// 提交实名认证---带滑块
interface ImgPersonalJson {
    front_id: string,
    back_id: string,
    idcard_front: string,
    idcard_back: string,
    sessionid: string,
    nctoken: string,
    sig: string,
    scene: string,
}
export const imgPersonal = (json: ImgPersonalJson): any => http.httpPost({
    url: httpApi.user.imgPersonal,
    json,
})

// 以认证用户实名的账号数

interface CountIdCardJson {
    token: string,
}
export const countIdCard = (): any => http.httpGet({
    url: httpApi.user.countIdCard,
})

export const authLimit = (): any => http.httpGet({
    url: httpApi.user.authLimit,
})
